import { render, staticRenderFns } from "./ModeloPersonalizado.vue?vue&type=template&id=6000ac2b&scoped=true"
import script from "./ModeloPersonalizado.vue?vue&type=script&lang=js"
export * from "./ModeloPersonalizado.vue?vue&type=script&lang=js"
import style0 from "./ModeloPersonalizado.vue?vue&type=style&index=0&id=6000ac2b&prod&lang=css"
import style1 from "./ModeloPersonalizado.vue?vue&type=style&index=1&id=6000ac2b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000ac2b",
  null
  
)

export default component.exports